






import { Component, Vue } from "vue-property-decorator";

@Component
export default class DownloadButton extends Vue {
  emitClick(): void {
    this.$emit('click');
  }
}
